const mergeArrays = (arrays) => [].concat.apply([], arrays);

export default mergeArrays;
